import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Settings,
  Users,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  Shield,
  UserCheck,
  Megaphone,
  Zap,
  Monitor,
  Upload,
  Package,
  Wrench,
  Armchair,
  MapPin,
  BarChart3,
  Truck,
  Warehouse,
  IndianRupee,
  ReceiptText,
  HomeIcon,
  CheckCheckIcon,
  Building2Icon,
  BadgeIndianRupee,
  X,
  NotebookPen,
  Coins,
  Settings2,
  Wallet,
  Package2,
  DollarSign,
  CreditCard,
  PiggyBank,
  CircleDashedIcon,
  TicketIcon,
  ChartScatterIcon,
  CoinsIcon,
  NotebookTabs,
  Clock,
  MessageCircle,
  BotIcon,
  LayoutDashboard,
  Repeat,
  ShoppingBag,
  UserCog,
  Box,
  ChartBarIcon,
  TouchpadIcon,
  FileBarChart,
  Calendar,
  Book,
  Brain,
  User,
  Globe,
  FolderOpen,
  Star,
  Smartphone,
  TabletSmartphone,
} from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../images/Elevate white.png';
import { hasPermission } from '../../utils/permissionUtils';
import { allReduxClear } from '../../utils/utils';
import { getElevateUser } from '../../storage/Storage';
import { setPagination } from '../../redux/Actions/TableAction';
import { UsersIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'rizzui';

const SideBar = ({ isCollapsed, onToggleCollapse, setHideSideBar, onMobileClose, isMobile }) => {
  const userData = useSelector((state) => state.UserReducer?.user);
  const dispatch = useDispatch();
  const [noGst, setNoGst] = useState(false);
  const userInitial = userData?.username ? userData.username.charAt(0).toUpperCase() : 'U';
  const [expandedItem, setExpandedItem] = useState(null);

  console.log("Sidebar props:", { isCollapsed, isMobile }); // Debug log

  useEffect(() => {
    const userData = getElevateUser();
    setNoGst(userData?.roleData?.noGst);
  }, []);

  const navigationItems = [
    {
      icon: <HomeIcon className="w-5 h-5" />,
      label: 'Dashboard',
      to: '/',
      module: 'dashboard',
    },

    {
      icon: <IndianRupee className="w-5 h-5" />,
      label: 'Quick Sale',
      to: '/quicksale',
      module: 'quicksale',
    },
    {
      icon: <Repeat className="w-5 h-5" />,
      label: 'Staff Billing',
      to: '/staffBilling',
      module: 'staffBilling',
    },
    {
      icon: <NotebookTabs className="w-5 h-5" />,
      label: 'Auto Billing',
      to: '/autoBilling',
      module: 'autoBilling',
    },
    {
      icon: <DollarSign className="w-5 h-5" />,
      label: 'Expense',
      to: '/expense',
      module: 'expense',
    },
    {
      icon: <CoinsIcon className="w-5 h-5" />,
      label: 'Bill Management',
      to: '/bills',
      module: 'bills',
    },
    {
      icon: <CreditCard className="w-5 h-5" />,
      label: 'Payments',
      to: '/payments',
    },
    {
      icon: <Smartphone className="w-5 h-5" />,
      label: 'App Bookings',
      to: '/app-bookings',
    },
    {
      icon: <Calendar className="w-5 h-5" />,
      label: 'Book Appoinments',
      to: '/appoinments',
      // module: 'appoinments',
    },




    // kugigui
    {
      icon: <FileBarChart className="w-5 h-5" />,
      label: 'Reports Management',
      module: 'reports',
      children: [
        {
          icon: <Users className="w-4 h-4" />,
          label: 'Staff Reports',
          to: '/reports/staff',
        },
        {
          icon: <FileBarChart className="w-4 h-4" />,
          label: 'Payment Distribution',
          to: '/reports/payment-distribution',
        },
        {
          icon: <Calendar className="w-4 h-4" />,
          label: 'Attendance Reports',
          to: '/reports/attendance',
          module: 'attendanceReports',
        },
        {
          icon: <Book className="w-4 h-4" />,
          label: 'Bills Reports',
          to: '/reports/bills',
          module: 'billsReports',
        }
      ],
    },

    {
      icon: <Shield className="w-5 h-5" />,
      label: 'Role And Permission',
      to: '/roles-and-permission',
      module: 'rolesAndPermissions',
    },
    {
      icon: <Users className="w-5 h-5" />,
      label: 'User Management',
      to: '/users',
      module: 'user',
    },
    {
      icon: <Clock className="w-5 h-5" />,
      label: 'Attendance Management',
      to: '/attendance',
      module: 'attendance',
    },
    {
      icon: <MapPin className="w-5 h-5" />,
      label: 'Unit Management',
      to: '/unit',
      module: 'unit',
    },
    {
      icon: <UserCheck className="w-5 h-5" />,
      label: 'Client Management',
      to: '/client',
      module: 'client',
    },
    {
      icon: <MessageCircle className="w-5 h-5" />,
      label: 'Client Follow-Up ',
      to: '/clientFollowUp',
      module: 'followup',
    },
    {
      icon: <Star className="w-5 h-5" />,
      label: 'Client Feedback',
      to: '/client-feedback',
    },
    {
      icon: <ChartBarIcon className="w-5 h-5" />,
      label: 'Client Analytics ',
      to: '/clientAnalytics',
      module: 'clientAnalysis',
    },
    {
      icon: <Brain className="w-5 h-5" />,
      label: 'Business Forecasting',
      to: '/businessForecasting',
      // module: 'businessForecasting',
    },
    {
      icon: <Wallet className="w-5 h-5" />,
      label: 'Wallet Management',
      to: '/wallet',
      module: 'wallet',
    },
    {
      icon: <Coins className="w-5 h-5" />,
      label: 'Account Management',
      to: '/account',
      module: 'account',
    },
    {
      icon: <TicketIcon className="w-5 h-5" />,
      label: 'Coupon Management',
      to: '/coupon',
      module: 'coupon',
    },

    {
      icon: <Truck className="w-5 h-5" />,
      label: 'Vendor Management',
      to: '/vendormanagement',
      module: 'vendor',
    },

    {
      icon: <Warehouse className="w-5 h-5" />,
      label: 'Buy Stock',
      module: 'stock',
      children: [
        {
          icon: <Warehouse className="w-4 h-4" />, // Wearhouse
          label: 'Buy Stock',
          to: '/stock/buy',
        },
        {
          icon: <Box className="w-4 h-4" />, // Wearhouse
          label: 'Orders',
          to: '/stock/orders',
        },
      ]

    },

    {
      icon: <Truck className="w-5 h-5" />,
      label: 'Stock Management',
      module: 'stock',
      children: [
        {
          icon: <Warehouse className="w-4 h-4" />, // Wearhouse
          label: 'Warehouse',
          to: '/stock/warehouse',
        },
        {
          icon: <UserCog className="w-4 h-4" />, // Professionals
          label: 'Professionals',
          to: '/stock/professionals',
        },
        {
          icon: <ShoppingBag className="w-4 h-4" />, // Retails
          label: 'Retails',
          to: '/stock/retails',
        },

        {
          icon: <LayoutDashboard className="w-4 h-4" />, // Shelf Dashboard
          label: 'Shelf Dashboard',
          to: '/stock/dashboard',
        },
      ],
    },

    {
      icon: <UsersIcon className="w-5 h-5" />,
      label: 'Membership',
      to: '/membership',
      module: 'membership',
    },

    {
      icon: <Package2 className="w-5 h-5" />,
      label: 'Packages',
      to: '/packages',
      module: 'packages',
    },

    {
      icon: <BarChart3 className="w-5 h-5" />,
      label: 'Staff Dashboard',
      to: '/staffdashboard',
      module: 'staff',
    },

    {
      icon: <CheckCheckIcon className="w-5 h-5" />,
      label: 'Task Management',
      to: '/taskmanagement',
      module: 'task',
    },
    {
      icon: < TouchpadIcon className="w-5 h-5" />,
      label: 'My Tasks',
      to: '/taskmanagement/task',
      module: 'task',
    },

    {
      icon: <Package className="w-5 h-5" />,
      label: 'Products',
      module: 'product',
      children: [
        {
          icon: <Package className="w-4 h-4" />,
          label: 'All Products',
          to: '/products',
          module: 'product',
        },
        {
          icon: <Package className="w-4 h-4" />,
          label: 'Master Products',
          to: '/master-products',
          module: 'product',
        },
      ],
    },
    {
      icon: <Wrench className="w-5 h-5" />,
      label: 'Services',
      module: 'services',
      children: [
        {
          icon: <Wrench className="w-4 h-4" />,
          label: 'Master Services',
          to: '/master-services',
          module: 'services',
        },
        {
          icon: <Wrench className="w-4 h-4" />,
          label: 'Service Dashboard',
          to: '/service-dashboard',
          module: 'services',
        },
        {
          icon: <Wrench className="w-4 h-4" />,
          label: 'Color Service',
          to: '/service-color',
          // module: 'services',
        },
      ],
    },
    {
      icon: <Settings2 className="w-5 h-5" />,
      label: 'General Service',
      to: '/generalmaster',
      module: 'generalMaster',
    },
    {
      icon: <Package className="w-5 h-5" />,
      label: 'Inventory Management',
      module: 'inventory',
      children: [
        {
          icon: <Package className="w-4 h-4" />,
          label: 'Inventory',
          to: '/inventory-management',
          module: 'inventory',
        },
      ],
    },
    {
      icon: <Megaphone className="w-5 h-5" />,
      label: 'Marketing Hub',
      module: 'advertisement',
      children: [
        {
          icon: <Monitor className="w-4 h-4" />,
          label: 'Devices',
          to: '/registerdevice',
          module: 'advertisement',
        },
        {
          icon: <Monitor className="w-4 h-4" />,
          label: 'Billboard',
          to: '/billboard',
          module: 'advertisement',
        },
      ],
    },
    {
      icon: <TouchpadIcon className="w-5 h-5" />,
      label: 'Kiosk Management',
      to: '/kiosk-management',
    },
    {
      icon: <User className="w-5 h-5" />,
      label: 'App Configuration',
      children: [
        {
          icon: <FolderOpen className="w-4 h-4" />,
          label: 'Projects',
          to: '/app-configuration/projects',
        },
        {
          icon: <CreditCard className="w-4 h-4" />,
          label: 'Payment Method',
          to: '/app-configuration/payment-method',
        },
      ],
    },
    {
      icon: <Zap className="w-5 h-5" />,
      label: 'App Control',
      to: '/app-control',
      module: 'appcontrol',
    },
    {
      icon: <TabletSmartphone className="w-5 h-5" />,
      label: 'Partner App Control',
      to: '/partner-app-control',
    },
    {
      icon: <HomeIcon className="w-5 h-5" />,
      label: 'Home Services',
      to: '/home-services',
    },
    {
      icon: <Settings className="w-5 h-5" />,
      label: 'App configuration ',
      to: '/appconfig',
    }



  ];

  const getVisibleNavigationItems = () => {
    return navigationItems.filter(item => {
      if (!item.module) return true;
      const userHasPermission = hasPermission(item.module, 'read');
      if (!userHasPermission) return false;
      if (item.children) {
        const visibleChildren = item.children.filter(child =>
          !child.module ? true : hasPermission(child.module, 'read')
        );
        if (visibleChildren.length > 0) {
          item.children = visibleChildren;
          return true;
        }
        return false;
      }
      return true;
    });
  };

  const visibleNavigationItems = getVisibleNavigationItems();

  useEffect(() => {
    if (visibleNavigationItems.length === 1) {
      setHideSideBar(true);
    } else {
      setHideSideBar(false);
    }
  }, [visibleNavigationItems, setHideSideBar]);

  const toggleExpand = (label) => {
    setExpandedItem(expandedItem === label ? null : label);
  };

  // Handle navigation click on mobile
  const handleNavClick = () => {
    console.log("Nav click - closing mobile sidebar"); // Debug log
    if (isMobile && onMobileClose) {
      onMobileClose();
    }
    // allReduxClear(dispatch);
    dispatch(setPagination({}))
  };

  return (
    <div
      className={`
        h-full bg-black text-white flex flex-col
        ${isCollapsed && !isMobile ? 'w-16' : 'w-64'}
      `}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-700 flex-shrink-0">
        {(!isCollapsed || isMobile) && (
          <div className="w-full flex items-center">
            <img src={logo} alt="elevatelogo" className="h-10" />
          </div>
        )}

        {/* Toggle/Close Button */}
        <button
          onClick={onToggleCollapse}
          className="p-2 hover:bg-gray-700 rounded-full transition-colors"
        >
          {isMobile ? (
            <X className="w-5 h-5" />
          ) : (
            isCollapsed ? <ChevronRight className="w-5 h-5" /> : <ChevronLeft className="w-5 h-5" />
          )}
        </button>
      </div>

      {/* Navigation */}
      <nav className="mt-4 flex-1 overflow-hidden">
        <ul className="space-y-2 px-2 h-full overflow-y-auto pb-24">
          {visibleNavigationItems.map((item) => (
            <li key={item.label}>
              <div className="flex flex-col">
                {item.children ? (
                  isCollapsed && !isMobile ? (
                    <Tooltip content={item.label} placement="right">
                      <div
                        className={`
                          flex items-center p-2 rounded-lg cursor-pointer
                          hover:bg-gray-700 transition-colors
                          justify-center
                        `}
                        onClick={() => {
                          toggleExpand(item.label);
                          // Don't close sidebar when expanding menu items
                        }}
                      >
                        <div className="flex items-center">
                          {item.icon}
                        </div>
                      </div>
                    </Tooltip>
                  ) : (
                    <div
                      className={`
                        flex items-center p-2 rounded-lg cursor-pointer
                        hover:bg-gray-700 transition-colors
                        justify-between
                      `}
                      onClick={() => {
                        toggleExpand(item.label);
                        // Don't close sidebar when expanding menu items
                      }}
                    >
                      <div className="flex items-center">
                        {item.icon}
                        <span className="ml-3 text-sm">{item.label}</span>
                      </div>
                      <div className="ml-2">
                        {expandedItem === item.label ? (
                          <ChevronUp className="w-4 h-4" />
                        ) : (
                          <ChevronDown className="w-4 h-4" />
                        )}
                      </div>
                    </div>
                  )
                ) : (
                  isCollapsed && !isMobile ? (
                    <Tooltip content={item.label} placement="right">
                      <NavLink
                        to={item.to}
                        onClick={handleNavClick}
                        className={({ isActive }) => `
                          flex items-center p-2 rounded-lg
                          hover:bg-gray-700 transition-colors
                          ${isActive ? 'bg-gray-700' : ''}
                          justify-center
                        `}
                      >
                        <div className="flex items-center">
                          {item.icon}
                        </div>
                      </NavLink>
                    </Tooltip>
                  ) : (
                    <NavLink
                      to={item.to}
                      onClick={handleNavClick}
                      className={({ isActive }) => `
                        flex items-center p-2 rounded-lg
                        hover:bg-gray-700 transition-colors
                        ${isActive ? 'bg-gray-700' : ''}
                        justify-between
                      `}
                    >
                      <div className="flex items-center">
                        {item.icon}
                        <span className="ml-3 text-sm">{item.label}</span>
                      </div>
                    </NavLink>
                  )
                )}

                {(!isCollapsed || isMobile) && item.children && expandedItem === item.label && (
                  <ul className="ml-4 mt-2 space-y-2">
                    {item.children.map((child) => (
                      <li key={child.label}>
                        <NavLink
                          to={child.to}
                          onClick={handleNavClick}
                          className={({ isActive }) => `
                            flex items-center p-2 text-sm text-gray-300 rounded-lg 
                            hover:bg-gray-700 transition-colors
                            ${isActive ? 'bg-gray-700 text-white' : ''}
                          `}
                        >
                          {child.icon}
                          <span className="ml-3">{child.label}</span>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </li>
          ))}
        </ul>
      </nav>

      {/* User Info */}
      <div className="flex-shrink-0 p-4 border-t border-gray-700">
        {(!isCollapsed || isMobile) ? (
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-white text-black rounded-full flex items-center justify-center font-bold">
              {userInitial}
            </div>
            <div>
              <p className="text-sm font-medium">{userData?.name || 'Loading...'}</p>
              <p className="text-xs text-gray-400">{userData?.username || 'User'}</p>
            </div>
          </div>
        ) : (
          <div className="flex justify-center">
            <div className="w-10 h-10 bg-white text-black rounded-full flex items-center justify-center font-bold">
              {userInitial}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SideBar;